import React, { useEffect, useRef } from 'react';
import useIsMobile from 'lib/useIsMobile';
import AppStore from 'assets/AppStore.png';
import GooglePlay from 'assets/GooglePlay.png';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Main from 'ripple/Containers/Main';
import { openAppStore, openPlayStore } from '../utils/helper';

const DownloadApp = () => {
  const mobile = useIsMobile();
  const appStoreRef = useRef(null);
  const playStoreRef = useRef(null);
  const openAppRef = useRef(null);

  const openApp = () => {
    const isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
    const isiOS = /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
    let storeLink = null;
    if (isAndroid) {
      storeLink = playStoreRef.current;
    } else if (isiOS) {
      storeLink = appStoreRef.current;
    }

    let timeout;

    // Event listener for visibility change
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        clearTimeout(timeout);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    timeout = setTimeout(() => {
      if (storeLink) {
        storeLink?.click();
      }
    }, 1500);

    if (isAndroid || isiOS) {
      openAppRef?.current.click();
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearTimeout(timeout);
    };
  };

  useEffect(() => {
    if (openAppRef?.current && playStoreRef?.current && appStoreRef?.current) {
      return openApp();
    }
  }, [openAppRef?.current, playStoreRef?.current, appStoreRef?.current]);

  return (
    <Main>
      <Card style={{ textAlign: 'center', height: '100%' }}>
        <CardHeader title='Download the app now and experience exclusive events like never before!' />
        <CardContent>
          <img
            role='presentation'
            onKeyDown={openAppStore}
            ref={appStoreRef}
            style={{
              ...(mobile
                ? {
                    width: '45%',
                    margin: '1%',
                  }
                : {
                    width: '15%',
                    margin: '2%',
                  }),
              height: 'auto',
              position: 'relative',
              cursor: 'pointer',
            }}
            src={AppStore}
            alt='appstore'
            onClick={openAppStore}
          />
          <a
            ref={openAppRef}
            href={`${window?.location?.origin}/`}
            target='_blank'
            style={{ display: 'none' }}
            rel='noreferrer'
          >
            Open Ripple Street App
          </a>

          <img
            role='presentation'
            onKeyDown={openPlayStore}
            ref={playStoreRef}
            style={{
              ...(mobile
                ? {
                    width: '45%',
                    margin: '1%',
                  }
                : {
                    width: '15%',
                    margin: '2%',
                  }),
              height: 'auto',
              position: 'relative',
              cursor: 'pointer',
            }}
            src={GooglePlay}
            alt='playstore'
            onClick={openPlayStore}
          />
        </CardContent>
      </Card>
    </Main>
  );
};

export default DownloadApp;
